<template>
  <div class="leading-normal">
    <div class="w-full flex flex-wrap">
      <div class="w-full md:w-1/3 md:pr-4 mb-6">
        <label for="category" class="block text-sm mb-2">Category: <span class="text-print-order-teal">*</span></label>
        <select v-model="orderItem.category" id="category" name="category" class="w-full border px-2 py-3" tabindex="1">
          <option :value="null">Select product...</option>
          <option v-for="(category, i) in products" :key="i" :value="category.id">{{ category.name }}</option>
        </select>
        <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('category')" v-text="errorBag.get('category')"></small>
      </div>
      <div class="w-full md:w-1/3 md:pr-4 mb-6">
        <label for="product" class="block text-sm mb-2">
          Product: <span class="text-print-order-teal">*</span>
          <i v-if="categoryName === 'Company Folders'" class="fas fa-info-circle text-blue ml-2 cursor-pointer" @click="showFolderImages = true" />
          <modal
            width="70vw"
            v-if="categoryName === 'Company Folders' && showFolderImages !== false"
            @leave="showFolderImages = false"
            show-close-btn
          >
            <div class="mb-2">
              <span class="pr-6 font-bold">Folder type:</span>
              <a class="pr-6 hover:underline" :class="showFolderType === 'interlocking' ? 'text-print-order-teal cursor-default underline' : 'cursor-pointer'" @click="showFolderType = 'interlocking'">Interlocking folders</a>
              <a class="hover:underline" :class="showFolderType === 'glued' ? 'text-print-order-teal cursor-default underline' : 'cursor-pointer'" @click="showFolderType = 'glued'">Glued folders</a>
            </div>
            <img v-if="showFolderType === 'interlocking'" src="img/print/folders/folders-interlocking.jpg" alt="Interlocking folders" />
            <img v-if="showFolderType === 'glued'" src="img/print/folders/folders-glued.jpg" alt="Glued folders" />
          </modal>
        </label>
        <select v-model="orderItem.product" id="product" name="product" :disabled="orderItem.category === null" class="w-full border px-2 py-3" tabindex="2">
          <option :value="null">Select item</option>
          <option v-for="(product, i) in categoryProducts" :key="i" :value="product.id">{{ product.name }}</option>
        </select>
        <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('product')" v-text="errorBag.get('product')"></small>
      </div>
      <div class="w-full md:w-1/3 mb-6">
        <label for="quantity" class="block text-sm mb-2">Quantity: <span class="text-print-order-teal">*</span></label>
        <input v-if="isVariableQuantity" v-model.number="orderItem.quantity" @blur="orderItem.quantity = setValidQuantity($event.target.value)" type="number" id="quantity" name="quantity" class="input w-full bg-white text-grey-darkest" tabindex="3" />
        <select v-else v-model="orderItem.quantity" id="quantity" name="quantity" :disabled="orderItem.product === null || prices.length === 0" class="w-full border px-2 py-3" tabindex="3">
          <option v-for="(qty, i) in qtyOptions" :key="i" :value="qty.name">{{ i === 0 ? qty.name + ' (Minimum Order)' : qty.name }}</option>
        </select>
        <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('quantity')" v-text="errorBag.get('quantity')"></small>
      </div>
      <div v-if="orderItem.artwork_type_id" class="w-full md:w-1/3 mb-6">
        <div class="md:mr-4">
          <label for="artwork" class="block text-sm mb-2">Artwork: <span class="text-print-order-teal">*</span></label>
          <select v-model="orderItem.artwork_type_id" id="artwork" name="artwork" class="w-full border px-2 py-3" tabindex="12">
            <option :value=1>Studio to create</option>
            <option v-if="!fineAndCountry" :value=2>Agent to supply</option>
            <option :value=3>Reuse from previous order</option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="customFields && customFields.length > 0 && orderItem.artwork_type_id !== 2" class="w-full flex flex-wrap">
      <print-order-custom-field v-for="(customField, i) in customFields" :key="i" :customField="customField" :count="i" :orderItem="orderItem" :errorBag="errorBag" />
    </div>
    <div v-if="categoryName === 'Refined Magazine' || categoryName === 'Exclusive Home Worldwide Magazine'">
      <div v-if="orderItem.quantity">
        <loader v-if="orderItem.properties === null || orderItem.properties === undefined" />
        <print-order-properties v-else :orderItem="orderItem" :propertySpec="propertySpec" :propertyFields="propertyFields" :issues="issues" :officeId="officeId" :errorBag="errorBag" />
      </div>
    </div>
    <div v-else-if="specifications.hasOwnProperty('combined_options') && !isEmpty(specifications.combined_options)" class="md:-mr-4">
      <h2 class="mt-4 mb-4 text-sm font-bold">Specification</h2>
      <div class="w-full flex flex-wrap">
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="document_size" class="block text-sm mb-2">Size: <span v-if="specifications.combined_options.document_size.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.document_size.length > 1" v-model="orderItem.specification.document_size" id="document_size" name="document_size" class="w-full border px-2 py-3" tabindex="4">
              <option v-for="(size, i) in specifications.combined_options.document_size" :key="i" :value="size">{{ size }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.document_size" type="text" disabled="disabled" id="document_size" name="document_size" class="input w-full bg-grey-lightest text-grey" tabindex="4" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.document_size')" v-text="errorBag.get('specification.document_size')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="extent" class="block text-sm mb-2">Extent: <span v-if="specifications.combined_options.extent.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.extent.length > 1" v-model="orderItem.specification.extent" id="extent" name="extent" class="w-full border px-2 py-3" tabindex="5">
              <option v-for="(extent, i) in specifications.combined_options.extent" :key="i" :value="extent">{{ extent }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.extent" type="text" disabled="disabled" id="extent" name="extent" class="input w-full bg-grey-lightest text-grey" tabindex="5" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.extent')" v-text="errorBag.get('specification.extent')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="orientation" class="block text-sm mb-2">Orientation: <span v-if="specifications.combined_options.orientation.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.orientation.length > 1" v-model="orderItem.specification.orientation" id="orientation" name="orientation" class="w-full border px-2 py-3" tabindex="6">
              <option v-for="(orientation, i) in specifications.combined_options.orientation" :key="i" :value="orientation">{{ orientation }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.orientation" type="text" disabled="disabled" id="orientation" name="orientation" class="input w-full bg-grey-lightest text-grey" tabindex="6" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.orientation')" v-text="errorBag.get('specification.orientation')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="stock_weight" class="block text-sm mb-2">Stock Weight: <span v-if="specifications.combined_options.stock_weight.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.stock_weight.length > 1" v-model="orderItem.specification.stock_weight" id="stock_weight" name="stock_weight" class="w-full border px-2 py-3" tabindex="7">
              <option v-for="(stock_weight, i) in specifications.combined_options.stock_weight" :key="i" :value="stock_weight">{{ stock_weight }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.stock_weight" type="text" disabled="disabled" id="stock_weight" name="stock_weight" class="input w-full bg-grey-lightest text-grey" tabindex="7" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.stock_weight')" v-text="errorBag.get('specification.stock_weight')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="stock_type" class="block text-sm mb-2">Stock Type: <span v-if="specifications.combined_options.stock_type.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.stock_type.length > 1" v-model="orderItem.specification.stock_type" id="stock_type" name="stock_type" class="w-full border px-2 py-3" tabindex="8">
              <option v-for="(stock_type, i) in specifications.combined_options.stock_type" :key="i" :value="stock_type">{{ stock_type }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.stock_type" type="text" disabled="disabled" id="stock_type" name="stock_type" class="input w-full bg-grey-lightest text-grey" tabindex="8" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.stock_type')" v-text="errorBag.get('specification.stock_type')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="stock_brand" class="block text-sm mb-2">Stock Brand: <span v-if="specifications.combined_options.stock_brand.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.stock_brand.length > 1" v-model="orderItem.specification.stock_brand" id="stock_brand" name="stock_brand" class="w-full border px-2 py-3" tabindex="9">
              <option v-for="(stock_brand, i) in specifications.combined_options.stock_brand" :key="i" :value="stock_brand">{{ stock_brand }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.stock_brand" type="text" disabled="disabled" id="stock_brand" name="stock_brand" class="input w-full bg-grey-lightest text-grey" tabindex="9" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.stock_brand')" v-text="errorBag.get('specification.stock_brand')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="lamination" class="block text-sm mb-2">Lamination: <span v-if="specifications.combined_options.lamination.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.lamination.length > 1" v-model="orderItem.specification.lamination" id="lamination" name="lamination" class="w-full border px-2 py-3" tabindex="10">
              <option v-for="(lamination, i) in specifications.combined_options.lamination" :key="i" :value="lamination">{{ lamination }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.lamination" type="text" disabled="disabled" id="lamination" name="lamination" class="input w-full bg-grey-lightest text-grey" tabindex="10" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.lamination')" v-text="errorBag.get('specification.lamination')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="lamination_pages" class="block text-sm mb-2">Lamination Pages: <span v-if="specifications.combined_options.lamination_pages.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.lamination_pages.length > 1" v-model="orderItem.specification.lamination_pages" id="lamination_pages" name="lamination_pages" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(lamination_pages, i) in specifications.combined_options.lamination_pages" :key="i" :value="lamination_pages">{{ lamination_pages }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.lamination_pages" type="text" disabled="disabled" id="lamination_pages" name="lamination_pages" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.lamination_pages')" v-text="errorBag.get('specification.lamination_pages')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="cover_extent" class="block text-sm mb-2">Cover Extent: <span v-if="specifications.combined_options.cover_extent.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.cover_extent.length > 1" v-model="orderItem.specification.cover_extent" id="cover_extent" name="cover_extent" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(cover_extent, i) in specifications.combined_options.cover_extent" :key="i" :value="cover_extent">{{ cover_extent }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.cover_extent" type="text" disabled="disabled" id="cover_extent" name="cover_extent" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.cover_extent')" v-text="errorBag.get('specification.cover_extent')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="cover_stock_weight" class="block text-sm mb-2">Cover Stock Weight: <span v-if="specifications.combined_options.cover_stock_weight.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.cover_stock_weight.length > 1" v-model="orderItem.specification.cover_stock_weight" id="cover_stock_weight" name="cover_stock_weight" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(cover_stock_weight, i) in specifications.combined_options.cover_stock_weight" :key="i" :value="cover_stock_weight">{{ cover_stock_weight }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.cover_stock_weight" type="text" disabled="disabled" id="cover_stock_weight" name="cover_stock_weight" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.cover_stock_weight')" v-text="errorBag.get('specification.cover_stock_weight')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="cover_stock_type" class="block text-sm mb-2">Cover Stock Type: <span v-if="specifications.combined_options.cover_stock_type.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.cover_stock_type.length > 1" v-model="orderItem.specification.cover_stock_type" id="cover_stock_type" name="cover_stock_type" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(cover_stock_type, i) in specifications.combined_options.cover_stock_type" :key="i" :value="cover_stock_type">{{ cover_stock_type }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.cover_stock_type" type="text" disabled="disabled" id="cover_stock_type" name="cover_stock_type" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.cover_stock_type')" v-text="errorBag.get('specification.cover_stock_type')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="cover_stock_brand" class="block text-sm mb-2">Cover Stock Brand: <span v-if="specifications.combined_options.cover_stock_brand.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.cover_stock_brand.length > 1" v-model="orderItem.specification.cover_stock_brand" id="cover_stock_brand" name="cover_stock_brand" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(cover_stock_brand, i) in specifications.combined_options.cover_stock_brand" :key="i" :value="cover_stock_brand">{{ cover_stock_brand }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.cover_stock_brand" type="text" disabled="disabled" id="cover_stock_brand" name="cover_stock_brand" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.cover_stock_brand')" v-text="errorBag.get('specification.cover_stock_brand')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="cover_lamination" class="block text-sm mb-2">Cover Lamination: <span v-if="specifications.combined_options.cover_lamination.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.cover_lamination.length > 1" v-model="orderItem.specification.cover_lamination" id="cover_lamination" name="cover_lamination" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(cover_lamination, i) in specifications.combined_options.cover_lamination" :key="i" :value="cover_lamination">{{ cover_lamination }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.cover_lamination" type="text" disabled="disabled" id="cover_lamination" name="cover_lamination" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.cover_lamination')" v-text="errorBag.get('specification.cover_lamination')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="cover_lamination_pages" class="block text-sm mb-2">Cover Lamination Pages: <span v-if="specifications.combined_options.cover_lamination_pages.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.cover_lamination_pages.length > 1" v-model="orderItem.specification.cover_lamination_pages" id="cover_lamination_pages" name="cover_lamination_pages" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(cover_lamination_pages, i) in specifications.combined_options.cover_lamination_pages" :key="i" :value="cover_lamination_pages">{{ cover_lamination_pages }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.cover_lamination_pages" type="text" disabled="disabled" id="cover_lamination_pages" name="cover_lamination_pages" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.cover_lamination_pages')" v-text="errorBag.get('specification.cover_lamination_pages')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="fold" class="block text-sm mb-2">Fold: <span v-if="specifications.combined_options.fold.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.fold.length > 1" v-model="orderItem.specification.fold" id="fold" name="fold" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(fold, i) in specifications.combined_options.fold" :key="i" :value="fold">{{ fold }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.fold" type="text" disabled="disabled" id="fold" name="fold" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.fold')" v-text="errorBag.get('specification.fold')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/3 mb-6">
          <div class="md:mr-4">
            <label for="binding" class="block text-sm mb-2">Binding: <span v-if="specifications.combined_options.binding.length > 1" class="text-print-order-teal">*</span></label>
            <select v-if="specifications.combined_options.binding.length > 1" v-model="orderItem.specification.binding" id="binding" name="binding" class="w-full border px-2 py-3" tabindex="11">
              <option v-for="(binding, i) in specifications.combined_options.binding" :key="i" :value="binding">{{ binding }}</option>
            </select>
            <input v-else v-model.number="orderItem.specification.binding" type="text" disabled="disabled" id="binding" name="binding" class="input w-full bg-grey-lightest text-grey" tabindex="11" />
            <small class="block text-print-order-teal text-medium mt-2" v-if="errorBag.get('specification.binding')" v-text="errorBag.get('specification.binding')"></small>
          </div>
        </div>
      </div>
      <p class="text-grey-darker"><span class="text-print-order-teal">*</span> Required fields</p>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import PrintOrderCustomField from './PrintOrderCustomField.vue'
import PrintOrderProperties from './PrintOrderProperties.vue'

export default {
  components: {
    PrintOrderCustomField,
    PrintOrderProperties
  },
  data () {
    return {
      showFolderImages: false,
      showFolderType: 'interlocking'
    }
  },
  props: ['products', 'prices', 'specifications', 'customFields', 'propertySpec', 'propertyFields', 'issues', 'orderItem', 'categoryName', 'officeId', 'fineAndCountry', 'errorBag'],
  computed: {
    categoryProducts () {
      let category = this.products.filter(c => c.id === this.orderItem.category)
      if (category.length === 1) {
        return category[0].items
      }
    },
    isVariableQuantity () {
      for (let i = 0; i < this.prices.length; i++) {
        if (this.isVariableQuantityBand(this.prices[i])) {
          return true
        }
      }
      return false
    },
    minimumQuantity () {
      if (this.prices.length === 0) {
        return 0
      }
      return parseInt(this.prices[0].minimum_quantity)
    },
    qtyOptions () {
      let options = []

      for (let i = 0; i < this.prices.length; i++) {
        let qtyLabel = this.qtyLabel(this.prices[i].minimum_quantity, this.prices[i].maximum_quantity)
        let existingOption = options.find(option => qtyLabel === option.name && this.prices[i].value_increment === option.increment)
        if (existingOption) {
          existingOption.ids.push(this.prices[i].id)
          continue
        }
        options.push({
          ids: [this.prices[i].id],
          name: qtyLabel,
          max: this.prices[i].maximum_quantity,
          min: this.prices[i].minimum_quantity,
          increment: this.prices[i].value_increment
        })
      }

      return options
    }
  },
  watch: {
    prices: {
      handler () {
        this.orderItem.quantity = this.orderItem.quantity ? this.setValidQuantity(this.orderItem.quantity) : this.minimumQuantity
      }
    }
  },
  methods: {
    isEmpty,
    ...mapActions([
      'displayToastNotification'
    ]),
    qtyLabel (min, max) {
      if (max !== null && max > 0 && max > min) {
        return min + ' - ' + max
      }

      return min
    },
    setValidQuantity (value) {
      if (!this.isVariableQuantity) {
        return parseInt(value)
      }
      if (value < this.prices[0].minimum_quantity) {
        this.displayQtyChangeNotification('The quantity has been automatically set to the minimum allowed value')
        return parseInt(this.minimumQuantity)
      }
      let nextValue = null // When value is between bands, use minimum of next band
      let maxValue = this.minimumQuantity // When value exceeds all bands, use largest maximum quantity
      for (let i = 0; i < this.prices.length; i++) {
        maxValue = Math.max(maxValue, this.prices[i].maximum_quantity)
        if (value < this.prices[i].minimum_quantity) {
          nextValue = nextValue === null ? this.prices[i].minimum_quantity : Math.min(nextValue, this.prices[i].minimum_quantity)
          continue
        }
        if (this.prices[i].maximum_quantity > 0 && value > this.prices[i].maximum_quantity) {
          continue
        }
        if (this.prices[i].value_increment === 1) {
          return parseInt(value)
        }
        if ((value - this.prices[i].minimum_quantity) % this.prices[i].value_increment !== 0) {
          // When value is within band but doesn't match increment, use next highest increment
          let newValue = value + (value - this.prices[i].minimum_quantity) % this.prices[i].value_increment
          if (newValue > this.prices[i].maximum_quantity) {
            continue
          }
          this.displayQtyChangeNotification('The quantity has been automatically set to the next allowed value')
          return parseInt(newValue)
        }
        return parseInt(value)
      }
      if (value > maxValue) {
        this.displayQtyChangeNotification('The quantity has been automatically set to the maximum allowed value')
        return parseInt(maxValue)
      }
      this.displayQtyChangeNotification('The quantity has been automatically set to the next allowed value')
      return parseInt(nextValue)
    },
    isVariableQuantityBand (band) {
      let min = band.minimum_quantity
      let max = band.maximum_quantity
      if (max !== null && max > 0 && max > min) {
        return true
      }
    },
    displayQtyChangeNotification (message) {
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-bell',
        title: 'Quantity Updated',
        info: message
      })
    }
  }
}
</script>
